import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';

import InternalErrorBoundary from 'components/errors/InternalErrorBoundary';
import { A11yStateProvider } from 'context/A11yStateContext';
import { BrandContextProvider } from 'context/BrandContext';
import { FeatureFlagProvider } from 'context/FeatureFlagContext';

const PackWrapper = ({ children, rootElement, store = null, history = null }) => {
  const ReduxProvider = ({ children }) => {
    if (!store) return children;
    return <Provider store={store}>{children}</Provider>;
  };

  const ReactRouter = ({ children }) => {
    if (!history) return children;
    return <Router history={history}>{children}</Router>;
  };

  return (
    <InternalErrorBoundary>
      <ReduxProvider>
        <A11yStateProvider>
          <BrandContextProvider rootElement={rootElement}>
            <FeatureFlagProvider>
              <ReactRouter>{children}</ReactRouter>
            </FeatureFlagProvider>
          </BrandContextProvider>
        </A11yStateProvider>
      </ReduxProvider>
    </InternalErrorBoundary>
  );
};

PackWrapper.propTypes = {
  children: PropTypes.node,
  rootElement: PropTypes.object,
  store: PropTypes.object,
  history: PropTypes.object,
};

export default PackWrapper;
